import { Plan } from '../typings/api';

export function rewritePricesForDiscountedPlans(
  plans: Plan[],
  type: 'purchasable' | 'voucher-compatible' = 'purchasable',
): Plan[] {
  return plans
    .filter((p) => p.is_public && p.price && (type === 'purchasable' ? p.is_purchasable : p.is_voucher_compatible))
    .map((plan) => {
      if (plan?.discount) {
        plan.price.formatted = plan.discount.price.formatted;
      }
      return plan;
    });
}
